import axios from '@/jslib/axios'

export const shareGuestAddCustomer = data => {
  return axios({
    method: 'post',
    url: '/admin/order/share/guest/add/customer',
    data
  })
}

export const getShareGuestQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/share/guest/quote',
    data
  })
}

export const selectShareGuestQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/share/guest/quote/buy',
    data
  })
}

export const shareUserPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/policy/add/share/user',
    data
  })
}
export const removeShareUserPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/policy/remove/share/user',
    data
  })
}

export const sendUploadUser = data => {
  return axios({
    method: 'post',
    url: 'admin/share/guest/send/upload/user',
    data
  })
}

export const sendUploadReferrer = data => {
  return axios({
    method: 'post',
    url: '/admin/share/guest/send/upload/referrer',
    data
  })
}
export const uploadBankFile = data => {
  return axios({
    method: 'post',
    url: 'admin/share/guest/upload/bank_file',
    data
  })
}
export const reviewBankPayment = data => {
  return axios({
    method: 'post',
    url: 'admin/share/guest/bank/payment',
    data
  })
}
export const getUrlData = params => {
  return axios({
    method: 'get',
    url: 'admin/share/guest/get/url/data',
    params
  })
}
